// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6f72ab4","453":"8132eb42","732":"933ddb47","977":"f032557b"}[chunkId] + ".chunk.js";
};